if(!customElements.get('beacon-product-gallery'))customElements.define('beacon-product-gallery',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();
    this.controller=new AbortController();
    const signal=this.controller.signal,track=this.querySelector('.beacon-photo-track'),slides=[...this.querySelectorAll('.beacon-photo-slide')];
    if(!track||slides.length<2)return;
    const previous=this.querySelector('[data-gallery-prev]'),next=this.querySelector('[data-gallery-next]'),status=this.querySelector('[data-gallery-status]'),thumbs=[...this.querySelectorAll('[data-gallery-index]')];
    let index=0,frame=0;
    const refresh=()=>{
      index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
      previous.disabled=index===0;next.disabled=index===slides.length-1;
      const text=(index+1)+' / '+slides.length;if(status.textContent!==text)status.textContent=text;
      thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    };
    const go=i=>track.scrollTo({left:Math.max(0,Math.min(slides.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    previous.addEventListener('click',()=>go(index-1),{signal});next.addEventListener('click',()=>go(index+1),{signal});
    thumbs.forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.galleryIndex)),{signal}));
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(refresh);},{passive:true,signal});
    track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(index+(event.key==='ArrowRight'?1:-1));}},{signal});
    this.observer=new ResizeObserver(()=>{track.scrollTo({left:index*track.clientWidth,behavior:'instant'});refresh();});this.observer.observe(track);
    refresh();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});
